export default __webpack_public_path__ + "static/media/stepTwo.9d2b5b2c.png";